import { useState, useEffect } from "react";
import { PageOne } from "./PageOne";
import { PageTwo } from "./PageTwo";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import {
  clearCreatePaymentSuccess,
  createPaymentRequest,
} from "../../../redux/action";
import { toast } from "react-hot-toast";
import { AuthNav, SideNav } from "../../../components/Navbar/Webpages/AuthNav";
import { FaWallet, FaShieldAlt } from "react-icons/fa";
import CurrencyDisplay from "../../../components/Currency/CurrencyDisplay";

const Fund = () => {
  const [pages, setPages] = useState(0);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const [selectedToken, setSelectedToken] = useState({
    tokenName: "",
    logopath: "",
    address: "",
    network: "",
  });

  const [amount, setAmount] = useState(0);
  const [usdAmount, setUsdAmount] = useState(0);

  const dispatch = useDispatch();

  const {
    user,
    createPaymentLoading,
    createPaymentSuccess,
    createPaymentError,
  } = useSelector((state) => {
    const {
      success: { createPayment: createPaymentSuccess },
      errors: { createPayment: createPaymentError },
    } = state.ajaxStatuses;
    const { createPaymentLoading } = state.loadingIndicator;
    const { user } = state.userData;

    return {
      user,
      createPaymentLoading,
      createPaymentSuccess,
      createPaymentError,
    };
  });

  const formik = useFormik({
    initialValues: {
      type: "Deposite",
      fundAmount: "",
      imgReceiptUrl: "",
      transactionRef: "",
    },
    onSubmit: (prop) => {
      if (prop.imgReceiptUrl === "" && prop.transactionRef === "") {
        toast.error(
          "Please upload a receipt or enter a transaction reference ID",
          {
            duration: 4000,
          }
        );
      } else {
        prop.user = user._id;
        prop.email = user.email;
        prop.userName = user.userName;
        prop.fundAmount = usdAmount;
        dispatch(createPaymentRequest(prop));
      }
    },
  });

  useEffect(() => {
    if (createPaymentError) toast.error(createPaymentError);
    if (createPaymentSuccess) {
      toast.success(createPaymentSuccess);
      handleClose();
      dispatch(clearCreatePaymentSuccess());
    }
  }, [createPaymentError, createPaymentSuccess, dispatch]);

  const componentArray = [
    <PageOne
      pages={pages}
      setPages={setPages}
      selectedToken={selectedToken}
      setSelectedToken={setSelectedToken}
      amount={amount}
      setAmount={setAmount}
      usdAmount={usdAmount}
      setUsdAmount={setUsdAmount}
    />,
    <PageTwo
      pages={pages}
      setPages={setPages}
      selectedToken={selectedToken}
      amount={amount}
      setAmount={setAmount}
      formik={formik}
      createPaymentLoading={createPaymentLoading}
      usdAmount={usdAmount}
    />,
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <AuthNav showLogo={false} title={"Deposit Funds"} />
      <SideNav />

      <div className="container mx-auto max-w-xl px-4 py-8 md:py-12 pt-20">
        {/* Top Balance Widget */}
        {user && (
          <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-2xl p-6 mb-8 text-white shadow-lg flex items-center justify-between">
            <div>
              <p className="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">
                Current Balance
              </p>
              <h3 className="text-3xl font-heading font-bold">
                <CurrencyDisplay usdAmount={user.balance} />
              </h3>
            </div>
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
              <FaWallet className="text-xl text-white" />
            </div>
          </div>
        )}

        {/* Main Card */}
        <div className="bg-white rounded-3xl shadow-xl shadow-gray-200/50 overflow-hidden border border-gray-100">
          {/* Header & Progress */}
          <div className="bg-white p-6 border-b border-gray-100">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-heading font-bold text-gray-900">
                {pages === 0 ? "Select Method" : "Complete Payment"}
              </h2>
              <div className="flex items-center gap-2 text-green-600 text-xs font-bold bg-green-50 px-3 py-1 rounded-full">
                <FaShieldAlt /> Secure
              </div>
            </div>

            {/* Progress Bar */}
            <div className="relative h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="absolute top-0 left-0 h-full bg-primary transition-all duration-500 ease-out"
                style={{ width: pages === 0 ? "50%" : "100%" }}
              ></div>
            </div>
            <div className="flex justify-between mt-2 text-xs font-bold text-gray-400 uppercase tracking-wide">
              <span className={pages >= 0 ? "text-primary" : ""}>
                Step 1: Details
              </span>
              <span className={pages >= 1 ? "text-primary" : ""}>
                Step 2: Transfer
              </span>
            </div>
          </div>

          {/* Dynamic Content */}
          <div className="transition-all duration-300">
            {componentArray[pages]}
          </div>
        </div>

        <p className="text-center text-xs text-gray-400 mt-8 font-body">
          Deposits are processed automatically after network confirmation.
        </p>
      </div>
    </div>
  );
};

export default Fund;
